export default "__VITE_ASSET__DuBApI_M__"